import { AgreementService } from "@/common/api.service";
import { FETCH_AGREEMENT_DATA, RESET_STATE } from "./actions.type";
import { SET_AGREEMENT_DATA, SET_AGREEMENT_ERROR, STATE_RESET } from "./mutations.type";


const initialState = () => {
  return {
    agreementdata: [],
    agreementerror: [],
  }
};

export const state = initialState();

const actions = {

    async [FETCH_AGREEMENT_DATA](context, slug) {
      return await AgreementService.get(slug).then((response) => {
        context.commit(SET_AGREEMENT_DATA, response.data)
        return response
      }).catch(({ response }) =>{
        context.commit(SET_AGREEMENT_ERROR, response.data.errorMessage)
        return response
      })
    },

    [RESET_STATE]({ commit }) {
        commit(STATE_RESET)
    }

}

const mutations = {

    [SET_AGREEMENT_DATA](state, agreementdata) {
      state.agreementdata = agreementdata
    },
    [SET_AGREEMENT_ERROR](state, error) {
      state.clinicianerror = error
    },  
    [STATE_RESET](state) {
      Object.assign(state,initialState())
    }
  
  }

  const getters = {
    agreementdata(state) {
      return state.agreementdata;
    },  
  }
  
  export default {
      state,
      getters,
      actions,
      mutations
  };
  
